import { IMultisportEventsDataLabels } from '../../../../packages/types';

export const getMultisportEventsLabels = (dataLabels: IMultisportEventsDataLabels | null | undefined) => {
  return {
    winner: dataLabels?.winner ?? 'Winner',
    topEvents: dataLabels?.top_events ?? 'Top Events',
    final: dataLabels?.final ?? 'Final',
    football: dataLabels?.football ?? 'Football',
    basketball: dataLabels?.basketball ?? 'Basketball',
    tennis: dataLabels?.tennis ?? 'Tennis',
    cycling: dataLabels?.cycling ?? 'Cycling',
    handball: dataLabels?.handball ?? 'Handball',
    ice_hockey: dataLabels?.ice_hockey ?? 'Ice Hockey',
    motorsports: dataLabels?.motorsports ?? 'Motorsports',
    rugby_league: dataLabels?.rugby_league ?? 'Rugby League',
    cricket: dataLabels?.cricket ?? 'Cricket',
    roller_hockey: dataLabels?.roller_hockey ?? 'Roller Hockey',
    age_restriction: dataLabels?.age_restriction ?? 'WHAT DOES GAMBLING COST YOU? STOP ON TIME.',
  };
};

export type IMultisportEventsLabels = ReturnType<typeof getMultisportEventsLabels>;
